import http from '../../utils/Http/Http'

export const createCheckoutSession = async (phone_number: string, email: string, product_id: string) => {
	const response = await http({
		url: '/stripe/create-checkout-session',
		method: 'POST',
		data: {
			phone_number,
			email,
			product_id,
			amount: 0,
		},
	})

	return response.data
}
